import { render, staticRenderFns } from "./CariesRiskAssesment.vue?vue&type=template&id=a6d02f6c"
import script from "./CariesRiskAssesment.vue?vue&type=script&lang=js"
export * from "./CariesRiskAssesment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports